<script>
  import TriggersList from "../Popups/TriggersList.svelte";
  import { onMount } from "svelte";
  import { editStepNotes } from "../static";
  import {External, M} from "../../external";

  export let data;
  export let repeat;

  let defaultNote = "";

  onMount(function () {
    setDefaultNote();
  });

  const click = () => {
    let component;
    External.Tools.showWindow({
      title: M.AUTOMATION_TRIGERS,
      icon: External.Popup.ICON_EDIT,
      width: 500,
      customClass: "add-member-dialog",
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      markup: '<div class="popup-widget-wrapper bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new TriggersList({
            target: context.find(".bind-component")[0],
            props: {
              data: data.triggers ? data.triggers : [],
              onChange: () => {
                data.triggers = component.get();
                External.CPanel.setChanged(true);
              }
            }
          });
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      }
    });
  };

  function editNotes() {
    editStepNotes(data.stickyNotes, (notes) => {
      data.stickyNotes = notes;
      External.CPanel.setChanged(true);
      setDefaultNote();
    });
  }

  function setDefaultNote() {
    defaultNote = "";
    if (data && data.stickyNotes) {
      for (let note of data.stickyNotes) {
        defaultNote = note.active ? note.message : defaultNote;
      }
    }
  }

  function setRepeat() {
    repeat = !repeat;
    External.CPanel.setChanged(true);
  }
</script>

<div class="automation-row automation-row-no-lines mb-15">
  <div class="automation-action start-automation" on:click={click}>
    <div class="automation-icon flex align-center justify-center automation-start">
      <span class="material-icons-outlined"> play_arrow </span>
    </div>
    <div class="automation-content">
      <h6>{M.CLICK_TRIGGER_START}</h6>
      <h5>{M.YOU_CURRENTLY_HAVE} {data.triggers.length} {data.triggers.length === 1 ? M.TRIGGER : M.TRIGGERS}</h5>
    </div>
    <div class="automation-repeat flex">
      <a
        on:click|stopPropagation={setRepeat}
        class="automation-notes-icon flex-none {repeat ? 'red' : ''} rounded-effect"
        title="{M.REPEAT_ON_FINISH}"><span class="material-icons-outlined"> repeat </span></a
      >
    </div>
    <div class="automation-notes flex" style="font-family: 'Caveat';">
      <a
        on:click|stopPropagation={editNotes}
        class="automation-notes-icon flex-none {defaultNote ? 'red' : ''} rounded-effect"
        title={M.NOTES}><span class="material-icons-outlined"> sticky_note_2 </span></a
      >
      <span on:click|stopPropagation={editNotes} class="last-automation-note">{defaultNote}</span>
    </div>
  </div>
</div>
